export default __webpack_public_path__ + "static/media/cassandraimg.2b62c473.png";